import React from 'react';
import BackOfficeMenu from '../components/BackOfficeMenu';

function BackOffice() {
    return (
      <div>
          back office
          <BackOfficeMenu />
      </div>
    );
  }
  
  export default BackOffice;